import { useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import PublicPageNav from '../components/PublicPageNav';
import CommercialQuoteEngine from '../components/CommercialQuoteEngine';
import MultifamilyQuoteForm from '../components/MultifamilyQuoteForm';
import { INDUSTRIES } from '../lib/industryData';

export default function QuotePage() {
  const [params] = useSearchParams();
  const initial = params.get('type');
  const [type, setType] = useState(initial === 'multifamily' || INDUSTRIES[initial] ? initial : 'multifamily');
  return <div className="min-h-screen bg-zinc-950 text-white" data-testid="quote-page">
    <PublicPageNav testIdPrefix="quote" />
    <main className="max-w-5xl mx-auto px-4 sm:px-8 py-12">
      <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{ fontFamily: 'Barlow Condensed, sans-serif' }} data-testid="quote-heading">Build your NECS service program</h1>
      <label htmlFor="quote-facility-type" className="block text-sm text-zinc-300 mb-2">Facility type</label>
      <select id="quote-facility-type" value={type} onChange={e => setType(e.target.value)} className="bg-zinc-900 border border-zinc-600 rounded p-3 w-full sm:max-w-md mb-8" data-testid="quote-facility-type">
        <option value="multifamily">Multifamily community</option>
        {Object.entries(INDUSTRIES).map(([key, value]) => <option value={key} key={key}>{value.label}</option>)}
      </select>
      {type === 'multifamily' ? <MultifamilyQuoteForm /> : <CommercialQuoteEngine key={type} initialType={type} />}
    </main>
  </div>;
}